<template>
    <div class="reflect">
        <el-dialog
            title="钱包提现"
            :visible.sync="lookBillDialog"
            :close-on-click-modal="false"
        >
            <div v-if="bankCardList.length > 0">
                <div class="reflectBank">
                    <p style="margin:0;margin-right: 30px">到账银行卡</p>
                    <div>
                        <el-radio-group v-model="bankBindId">
                            <el-radio :label="item.uuid" class="reflectBank_box" :key="item.uuid" v-for="(item, index) in bankCardList">
                                <span>{{ item.shotCardNo }}({{ item.bankName }})</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="reflectMoney">
                    <div class="reflectMoney_box">
                        <p>提现金额</p>
                        <h3>￥</h3>
                        <input type="number" v-model="cashMoney" @change="validateCashMoney"/>
                    </div>
                    <p class="reflectMoney_text">当前零钱余额{{ balanceCount }}元，<span @click="cashMoney = balanceCount">全部提现</span></p>

                </div>
            </div>
            <div v-else>
                暂无绑定银行卡，请先绑定银行卡
            </div>

            <div class="reflect_btn">
                <el-button type="primary" @click="submit" v-if="bankCardList.length > 0">确认</el-button>
                <el-button @click="lookBillDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {cashOut, getBankCardInfoTotalList, getCashOutBalance} from "../../utils/interface";

export default {
    name: "reflect",
    data() {
        return {
            lookBillDialog: false,
            bankBindId: '',
            bankCardList: [],
            cashMoney: '',
            balanceCount: 0
        };
    },
    created() {
        this.getCashOutBalance();
        this.getBankCardList();
    },
    methods: {
        init() {
            this.lookBillDialog = true;
        },
        handleClick() {
        },
        submit() {
            if(!this.bankBindId) {
                this.$message.error('请选择提现银行卡！')
                return ;
            }
            if(this.cashMoney <= 0) {
                this.$message.error('请输入提现金额且提现金额大于0');
                return ;
            }

            cashOut({bankCardUuid:this.bankBindId,orderAmount:this.cashMoney}).then((res) => {
                if(res.success) {
                    this.$alert('提交成功银行正在处理，收到最终结果前请勿重复提交', '提交成功', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$message({
                                type: 'info',
                                message: `action: ${action}`
                            });

                            this.$emit('refreshCash');
                            setTimeout(() => {
                                this.lookBillDialog = false;
                            }, 400);
                        }
                    });
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        //获取可提现总金额
        getCashOutBalance() {
            getCashOutBalance().then((res) => {
                if(res.success) {
                    if(res.data)
                        this.balanceCount = res.data;
                }
            })
        },
        getBankCardList() {
            getBankCardInfoTotalList().then((res) => {
                this.bankCardList = res;
            })
        },
        validateCashMoney() {
            if(this.cashMoney > this.balanceCount) {
                this.$message.error('提现金额不能大于账户余额');
                this.cashMoney = this.balanceCount;
            }
        }
    },
};
</script>

<style lang="less" scoped>
p {
    margin: 0;
}

.reflectBank {
    display: flex;

    .reflectBank_box {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        img {
            width: 25px;
            height: 25px;
            margin-right: 15px;
        }

        /deep/ .el-radio__label {
            display: flex;
            align-items: center;
        }
    }
}

/deep/ .el-dialog {
    width: 30%;
}

.reflectMoney {
    .reflectMoney_box {
        display: flex;
        align-items: baseline;
        color: #666;

        input {
            border: none;
            outline: none;
            border-bottom: 1px solid #efefef;
        }

        h3 {
            font-size: 28px;
            margin-left: 15px;
        }
    }

    .reflectMoney_text {
        span {
            cursor: pointer;
            color: #409EFF;
        }
    }
}

.reflect_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 18px;

    button {
        margin-left: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/balance/reflect.vue